module.exports = __webpack_public_path__ + "static/media/about.096e9c83.svg";